
import React from 'react';
import $ from 'jquery';
import xlsx from "json-as-xlsx"
import pica from "pica";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

class Utility extends React.Component {


    static isEmpty(element) {

        if (element == undefined || element == "" || element == null) {

            return true;
        }

        return false;
    }

    static showAlert(holder, message, type, fade) {

        $('.' + holder).before(
            '<div class="alert alert-' + type + ' custom-alert">' + message + '</div>'
        );

        if (fade) {

            $('.custom-alert').delay(3000).fadeOut('slow');
        }


    }

    static showAlertWithId(holder, message, type, fade) {

        $('#' + holder).before(
            '<div class="alert alert-' + type + ' custom-alert text-center">' + message + '</div>'
        );

        if (fade) {

            $('.custom-alert').delay(3000).fadeOut('slow');
        }


    }

    static keyUpWithdelay(input, functionToCall, interval) {

        if (input.length == 0) {

            return;
        }

        let timer;

        $(input).on('keyup', function () {

            clearTimeout(timer);

            timer = setTimeout(functionToCall, interval);


        });


    }

    static jsonToExcel(documentName, jsondata) {

        let data = [
            {
                sheet: documentName,
                columns: [
                    { label: "Nom", value: "name" }, // Top level data
                    { label: "Modele", value: "model" }, // Custom format
                    { label: "Marque", value: "brand" },
                    { label: "Numero", value: "size" },
                    { label: "Couleur", value: "color" },
                    { label: "CPID", value: "supplierUniqueId" },
                    { label: "Prix", value: "price" },
                    { label: "Quantité", value: "quantity" },
                    { label: "Quantité Servie", value: "pickedQuantity" },
                    { label: "CBM", value: "boxCbm" },
                    { label: "Quantité Par Carton", value: "quantityInBox" },

                ],
                content: jsondata,
            }
        ]

        let settings = {
            fileName: documentName, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
            RTL: false, // Disp
        }

        xlsx(data, settings);

    }

    /*static exportJsonToExcel(documentName, columns, jsondata) {

        let data = [
            {
                sheet: documentName,
                columns: columns,
                content: jsondata,
            }
        ]

        let settings = {
            fileName: documentName, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
            RTL: false, // Disp
        }

        xlsx(data, settings);

    }*/



    static async exportJsonToExcel(fileName, columns, data, options = {}) {

        const workbook = new ExcelJS.Workbook();

        const worksheet = workbook.addWorksheet(fileName);

        worksheet.columns = columns.map(column => ({

            header: column.label,

            key: column.value,

            width: column.type === "image" ? 18 : 25

        }));

        worksheet.getRow(1).font = { bold: true };

        for (const item of data || []) {

            const rowData = {};

            columns.forEach(column => {

                if (column.type !== "image") {

                    rowData[column.value] = item[column.value] ?? "";

                }

            });

            const row = worksheet.addRow(rowData);

            const imageColumn = columns.find(column => column.type === "image");

            if (imageColumn && item[imageColumn.value]) {

                row.height = options.imageHeight || 80;

                const imageData = await Utility.getImageForExcel(item[imageColumn.value]);

                if (imageData) {

                    const imageId = workbook.addImage({

                        base64: imageData.base64,

                        extension: imageData.extension

                    });

                    const imageColumnIndex = columns.findIndex(

                        column => column.value === imageColumn.value

                    );

                    worksheet.addImage(imageId, {

                        tl: {

                            col: imageColumnIndex + 0.15,

                            row: row.number - 0.85

                        },

                        ext: {

                            width: options.imageWidth || 75,

                            height: options.imageHeight || 75

                        }

                    });

                }

            }

        }

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(

            new Blob([buffer], {

                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

            }),

            `${fileName}.xlsx`

        );

    }

    static async getImageForExcel(imageUrl) {

        try {

            const response = await fetch(imageUrl, {

                method: "GET",

                mode: "cors",

            });

            if (!response.ok) {

                console.log("Image not loaded:", imageUrl, response.status);

                return null;

            }

            const contentType = response.headers.get("content-type") || "";

            let extension = "jpeg";

            if (contentType.includes("png")) {

                extension = "png";

            } else if (contentType.includes("gif")) {

                extension = "gif";

            } else if (contentType.includes("jpg") || contentType.includes("jpeg")) {

                extension = "jpeg";

            }

            const blob = await response.blob();

            const base64 = await new Promise(resolve => {

                const reader = new FileReader();

                reader.onloadend = () => resolve(reader.result);

                reader.onerror = () => resolve(null);

                reader.readAsDataURL(blob);

            });

            if (!base64) {

                return null;

            }

            return {

                base64,

                extension

            };

        } catch (error) {

            console.log("Excel image export failed:", imageUrl, error);

            return null;

        }

    }

    static async imageUrlToBase64(url) {

        try {

            const response = await fetch(url, {

                method: "GET",

                mode: "cors"

            });

            if (!response.ok) {

                return null;

            }

            const blob = await response.blob();

            return await new Promise(resolve => {

                const reader = new FileReader();

                reader.onloadend = () => resolve(reader.result);

                reader.onerror = () => resolve(null);

                reader.readAsDataURL(blob);

            });

        } catch (error) {

            console.log("Unable to load Excel image:", error);

            return null;

        }

    }

    static getImageExtension(url) {

        if (!url) {

            return "jpeg";

        }

        const cleanUrl = url.toLowerCase().split("?")[0];

        if (cleanUrl.endsWith(".png")) {

            return "png";

        }

        if (cleanUrl.endsWith(".gif")) {

            return "gif";

        }

        return "jpeg";

    }




    static resizeImage = async (file, size) => {
        const dataUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });

        const img = await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = dataUrl;
        });

        const maxSize = size;
        let width = img.width;
        let height = img.height;

        if (width > maxSize || height > maxSize) {
            if (width > height) {
                height = Math.round((height * maxSize) / width);
                width = maxSize;
            } else {
                width = Math.round((width * maxSize) / height);
                height = maxSize;
            }
        }

        const fromCanvas = document.createElement("canvas");
        fromCanvas.width = img.width;
        fromCanvas.height = img.height;

        const fromCtx = fromCanvas.getContext("2d");
        fromCtx.drawImage(img, 0, 0);

        const toCanvas = document.createElement("canvas");
        toCanvas.width = width;
        toCanvas.height = height;

        await pica().resize(fromCanvas, toCanvas);

        const blob = await pica().toBlob(toCanvas, "image/jpeg", 0.85);

        const resizedDataUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });


        return resizedDataUrl;
    };


}

export default Utility;